import { render, staticRenderFns } from "./sale_preord_two.vue?vue&type=template&id=ed2186f6&scoped=true&"
import script from "./sale_preord_two.vue?vue&type=script&lang=js&"
export * from "./sale_preord_two.vue?vue&type=script&lang=js&"
import style0 from "./sale_preord_two.vue?vue&type=style&index=0&id=ed2186f6&scoped=true&lang=less&"
import style1 from "./sale_preord_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2186f6",
  null
  
)

export default component.exports